module.exports = __webpack_public_path__ + "img/Group 81.00c66e42.png";